// url 相关辅助函数，为了减小包体积，造了几个轮子
/**
 * 拼接参数
 * @param params
 * @param stringifyObject 是否序列化对象值
 */
function qsStringify(params, stringifyObject = true) {
    const arr = [];
    for (const key of Object.keys(params)) {
        let value = params[key];
        if (typeof value === 'undefined') {
            continue;
        }
        if (typeof value === 'object' && stringifyObject) {
            value = JSON.stringify(value);
        }
        arr.push(`${key}=${encodeURIComponent(value)}`);
    }
    return arr.join('&');
}
/**
 * 解析参数
 * @param paramStr
 * @param parseObject 是否解析对象参数
 */
function qsParse(paramStr, parseObject = true) {
    if (paramStr.indexOf('?') === 0) {
        paramStr = paramStr.slice(1);
    }
    const params = {};
    if (!paramStr) {
        return params;
    }
    const arr = paramStr.split('&');
    for (const item of arr) {
        const arr1 = item.split('=');
        let value = decodeURIComponent(arr1[1] || '');
        if (parseObject && (value[0] === '[' || value[0] === '{')) {
            try {
                value = JSON.parse(value);
            }
            catch (e) { }
        }
        params[arr1[0]] = value;
    }
    return params;
}
/**
 * 解析链接
 * @param url
 */
function urlParse(url) {
    const arr = url.split('//');
    const protocol = arr[0];
    arr.splice(0, 1);
    const arrHash = arr.join('//').split('#');
    const hash = arrHash.length > 1 ? '#' + arrHash[1] : '';
    const arrQuery = arrHash[0].split('?');
    const search = arrQuery.length > 1 ? '?' + arrQuery[1] : '';
    const pathStr = arrQuery[0];
    let pathname = '';
    let hostname = '';
    let host = '';
    if (protocol.indexOf('com.') === 0) {
        // 如果是appLink
        pathname = '/' + pathStr;
        hostname = '';
        host = '';
    }
    else {
        const arr2 = pathStr.split('/');
        host = arr2[0];
        const colonIndex = host.indexOf(':');
        hostname = colonIndex > 0 ? host.slice(0, colonIndex) : host;
        arr2.splice(0, 1);
        pathname = arr2.join('/');
        if (pathname) {
            pathname = '/' + pathname;
        }
    }
    return {
        protocol,
        host,
        hostname,
        pathname,
        search,
        hash
    };
}
/**
 * 给链接增加参数
 * @param url 链接
 * @param params 新的参数对象
 */
function addQuery(url, params) {
    const urlInfo = urlParse(url);
    const query = qsParse(urlInfo.search);
    Object.assign(query, params);
    return urlStringify(Object.assign({
        query
    }, urlInfo));
}
/**
 * 根据链接参数拼接完整的url
 * @param urlInfo
 * @returns
 */
function urlStringify(urlInfo) {
    const { protocol = '', host = '', pathname = '', query } = urlInfo;
    let search = query ? qsStringify(query) : urlInfo.search || '';
    if (search && search[0] !== '?') {
        search = `?${search}`;
    }
    let hash = urlInfo.hash || '';
    if (hash && hash[0] !== '#') {
        hash = `#${hash}`;
    }
    return `${protocol}${protocol ? '//' : ''}${host}${pathname}${search}${hash}`;
}
export { qsStringify, qsParse, urlParse, urlStringify, addQuery };
